// import Vue from 'vue'

const gamesModule = [
  { value: 15, label: 'DG真人视讯', type: 2, show: true }, // DG真人视讯
  { value: 69, label: 'EFG电子', type: 4, show: true }, // EFG
  { value: 18, label: '高登棋牌', type: 3, show: true }, // 高登棋牌
  { value: 88, label: '熊貓體育(GOLDEN)', type: 1, show: true }, // 熊貓體育(GOLDEN)
  { value: 108, label: 'DB彩球(GOLDEN)', type: 7, show: true },
  { value: 118, label: 'DB真人(Golden)', type: 2, show: true },
  { value: 20, label: 'PG电子', type: 4, show: true }, // PG电子
  { value: 33, label: 'GEMINI電子', type: 4, show: true }, // GEMINI電子
  { value: 34, label: 'SUPER體育', type: 1, show: true }, // GEMINI電子
  { value: 70, label: 'ATG電子', type: 4, show: true },
  { value: 13, label: '开元棋牌', type: 3, show: true }, // 开元棋牌
  { value: 35, label: '开元體育', type: 1, show: true }, // 开元棋牌
  { value: 72, label: '歐博真人', type: 2, show: true },
  { value: 73, label: 'WG真人', type: 2, show: true },
  { value: 74, label: 'WG體育', type: 2, show: true },
  { value: 76, label: 'WG彩球', type: 7, show: true },
  { value: 75, label: 'RSG电子', type: 4, show: true },
  { value: 77, label: 'BNG电子', type: 4, show: true },
  { value: 78, label: 'ZEBRA电子', type: 4, show: true },
  { value: 79, label: '9K彩球', type: 7, show: true },
  { value: 80, label: 'GB电子', type: 4, show: true },
  { value: 81, label: '平博體育', type: 1, show: true },
  { value: 82, label: '好路棋牌', type: 3, show: true },
  { value: 83, label: '好路電子', type: 4, show: true },
  { value: 84, label: '好路捕魚', type: 6, show: true },
  { value: 85, label: 'Spinix電子', type: 4, show: true },
  { value: 86, label: '開心棋牌', type: 3, show: true },
  { value: 87, label: '開心捕魚', type: 6, show: true },
  { value: 89, label: 'RG真人', type: 2, show: true },
  { value: 100, label: '太子彩球', type: 7, show: true },
  { value: 101, label: 'Qtech電子', type: 4, show: true },
  { value: 102, label: 'Astar真人', type: 2, show: true },
  { value: 103, label: 'WM真人', type: 2, show: true },
  { value: 104, label: 'WM電子', type: 4, show: true },
  { value: 105, label: 'MT真人', type: 2, show: true },
  { value: 106, label: 'MT彩球', type: 7, show: true },
  { value: 109, label: 'T9真人', type: 2, show: true },
  { value: 110, label: 'BE电子', type: 4, show: true },
  { value: 112, label: 'Live體育', type: 1, show: true },
  { value: 113, label: 'Splus电子', type: 4, show: true },
  { value: 114, label: 'Tag电子', type: 4, show: true },
  { value: 115, label: 'Hacksaw电子(gpk)', type: 4, show: true },
  { value: 116, label: '365體育', type: 1, show: true },
  { value: 117, label: 'SlotMill电子(gpk)', type: 4, show: true },
  { value: 119, label: '天群體育', type: 1, show: true },
  { value: 120, label: '金佰新', type: 2, show: true },
  { value: 121, label: 'BT視訊', type: 2, show: true },
  { value: 122, label: 'GC彩球', type: 7, show: true },
  { value: 123, label: 'AT電子', type: 4, show: true },
  { value: 124, label: 'T9電子', type: 4, show: true },
  { value: 21, label: 'CQ9电子', type: 4, show: true }, // CQ9电子
  { value: 24, label: '雷火电竞', type: 5, show: true }, // 雷火电竞
  { value: 43, label: 'SA真人', type: 2, show: true },
  { value: 44, label: 'Funky電子', type: 4, show: true },
  { value: 45, label: 'CR體育', type: 1, show: true },
  { value: 46, label: 'MB彈珠', type: 7, show: true }
  // { value: 22, label: 'ICG电子', type: 4, show: false }, // ICG电子
  // { value: 23, label: 'JDB电子', type: 4, show: false }, // JDB电子
  // { value: 25, label: '双赢棋牌', type: 3, show: false }, //  双赢棋牌
  // { value: 17, label: 'OG真人视讯', type: 2, show: false }, // OG真人视讯
  // { value: 16, label: 'BBIN真人视讯', type: 2, show: false }, // BBIN真人视讯
  // { value: 6, label: 'AG真人视讯', type: 2, show: false }, // AG真人视讯
  // { value: 19, label: 'AG捕魚', type: 6, show: false, detail: true }, // AG捕魚
  // { value: 14, label: 'BG', type: 2, show: false }, // BG真人视讯
  // { value: 26, label: '泛亚电竞', type: 5, show: false }, // 泛亚电竞
  // { value: 27, label: 'BG捕魚', type: 6, show: false }, // BG捕魚
  // { value: 28, label: 'OB體育', type: 1, show: false }, // OB體育
  // { value: 29, label: 'MS体育', type: 1, show: false }, // BET365体育
  // { value: 31, label: 'PP电子', type: 4, show: false } // PP电子
]

const state = {
  gamesModule: gamesModule,
  searchTimeType: [
    { value: 1, label: '投注時間' },
    { value: 2, label: '結算時間' },
    { value: 3, label: '開賽時間' }
  ]
}

export default {
  namespaced: true,
  state
}
